import React from 'react';
import Modal from 'react-bootstrap/Modal';
import {Trans} from 'react-i18next';
import button from 'bootstrap/js/src/button';
import {useSelector} from 'react-redux';
import smbUtils from '../../../../utils/smbUtils';
import storeUtils from '../../../../utils/storeUtils';

export default function UpgradeSuccessModal({show, setShow}) {
  const {customerId} = smbUtils.customerInfo(
    useSelector(state => state.components.auth.accountSummary)
  );

  return (
    <>
      <Modal
        size="l"
        show={show}
        centered={true}
        backdrop={'static'}
        enforceFocus={true}
      >
        <Modal.Header closeButton={false}>
          <Modal.Title>
            <Trans i18nKey="p.s.uiconfiguration.upgrade.modal.title">
              UI Configuration Feature Updated
            </Trans>
          </Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <div className="row">
            <div className="col-7">
              <Trans i18nKey="p.s.uiconfiguration.upgrade.modal.desc">
                <p>The update for UI Configuration has been completed.</p>
                <p>
                  With this new version, you will be able to configure the new
                  CRM pages.
                </p>
              </Trans>
            </div>
            <div className="col-5">
              <img
                style={{maxWidth: '100%'}}
                alt="UI Configuration"
                src={
                  'https://plugins-media.makeupar.com/smb/story/2023-12-13/b4437eb3-9aa4-4567-9fdf-9d6843a09ec8.jpg'
                }
                className="kt-margin-b-5 kt-margin-r-5"
              />
            </div>
          </div>
        </Modal.Body>
        <Modal.Footer>
          <div className="d-flex justify-content-end">
            <button
              className="btn btn-outline-secondary kt-margin-r-10"
              onClick={() => {
                storeUtils.removeUpdatedSuccess(customerId);
                setShow(false);
              }}
            >
              <Trans i18nKey="p.p.s.view.close">Close</Trans>
            </button>
          </div>
        </Modal.Footer>
      </Modal>
    </>
  );
}
